var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.986,
    viewBox: "0 0 30 29.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank-building",
    transform: "translate(0 -0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_78_",
    transform: "translate(0 0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M28.624,42.718H1.363a1.382,1.382,0,0,0,0,2.764h27.26a1.382,1.382,0,0,0,0-2.764Z",
    transform: "translate(0 -15.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M4.03,29.627a1.382,1.382,0,0,0,0,2.765H27.841a1.382,1.382,0,0,0,0-2.765H27.5V17.192h.34a.69.69,0,0,0,0-1.381H4.03a.69.69,0,0,0,0,1.381h.34V29.626H4.03ZM24.779,17.192V29.626H20.7V17.192Zm-6.8,0V29.626H13.894V17.192Zm-10.885,0h4.082V29.626H7.091Z",
    transform: "translate(-0.942 -5.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1.363,8.991H28.637a1.385,1.385,0,0,0,.442-2.69L15.554.133a1.349,1.349,0,0,0-1.118,0L.8,6.35A1.386,1.386,0,0,0,.031,7.9,1.367,1.367,0,0,0,1.363,8.991Z",
    transform: "translate(0 -0.012)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarIcon);
export default __webpack_public_path__ + "static/media/pillarIcon.79d71768d261c08c3a4c5ebc2a455505.svg";
export { ForwardRef as ReactComponent };